module.exports = __webpack_public_path__ + "img/contratos.814cafc9.png";